(function(){
  const root = document.getElementById('htb03-nativefinal');
  if (!root) return;
  const sticky = root.querySelector('.htb03nf-sticky');
  if (!sticky) return;
  const triggerText = 'INTRODUCING THE DEVICE THAT ACTUALLY RELIEVES HIP PAIN';
  const trigger = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,div,span,p'))
    .filter(function(el){ return (el.textContent || '').replace(/\s+/g,' ').trim().includes(triggerText); })
    .sort(function(a,b){ return (a.textContent||'').trim().length - (b.textContent||'').trim().length; })[0] || null;
  sticky.classList.remove('htb03nf-sticky-visible');
  let ticking = false;
  const revealPoint = () => {
    if (!trigger) return Math.min(700, document.documentElement.scrollHeight * 0.25);
    const triggerTop = trigger.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    return Math.max(0, triggerTop - (window.innerHeight * 0.70));
  };
  const update = () => {
    ticking = false;
    const y = window.scrollY || window.pageYOffset || 0;
    const point = revealPoint();
    if (y >= point) sticky.classList.add('htb03nf-sticky-visible');
    else if (y < point - 400) sticky.classList.remove('htb03nf-sticky-visible');
  };
  const requestUpdate = () => { if (ticking) return; ticking = true; window.requestAnimationFrame(update); };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  update();
})();
